/** Localized, dependency-free formatting helpers (Intl only — no dayjs/moment). */

/** Format an ISO timestamp as a friendly localized date-time, honouring the active locale tag. */
export function formatDateTime(iso: string, localeTag: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  try {
    return new Intl.DateTimeFormat(localeTag, { dateStyle: 'medium', timeStyle: 'short' }).format(d);
  } catch {
    return d.toLocaleString();
  }
}
